import { Component, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { BUSINESS_REG_APP_CONSTANT } from 'app/config/business-reg-app.constant';
import { LoaderService } from 'app/service/loader/loader.service';

@Component({
  selector: 'jhi-eappreg-fuzzy-match',
  templateUrl: './eappreg-fuzzy-match.component.html',
  styleUrls: ['./eappreg-fuzzy-match.component.scss']
})
export class EappregFuzzyMatchComponent implements OnInit {

  eAppRegConstant: any;
  cModalTitle = "";
  cModalBody = "";
  fForm: any
  selectedAddr: any;
  loaderService:any
  @Input() public tRCFuzzyMatches: any

  constructor(public activeModal: NgbActiveModal,
    private loader: LoaderService) {
      this.loaderService = this.loader;
  }

  ngOnInit(): void {
    this.eAppRegConstant = BUSINESS_REG_APP_CONSTANT;
  }

  proceed(): void {
    this.activeModal.close({ "reason": "PROCEED", selectedAddr: this.tRCFuzzyMatches[this.selectedAddr] })
  }
  cancel(): void {
    this.activeModal.close({ "reason": "CANCEL", selectedAddr: this.tRCFuzzyMatches[this.selectedAddr] })
  }
}
